var render, staticRenderFns
import script from "./Space.vue?vue&type=script&lang=js"
export * from "./Space.vue?vue&type=script&lang=js"
import style0 from "./Space.vue?vue&type=style&index=0&id=668e7283&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "668e7283",
  null
  
)

export default component.exports